/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CittadinoRegistrationForm { 
    email: string;
    nome: string;
    cognome: string;
    codice_fiscale: string;
}

